import { FormValues } from "../../form/duck";

export const DEFAULT_VALUES: FormValues = {
  frequency: null,
  dose: "",
  lastGivenAt: null,
  medication: ""
};
